import React, { useState } from 'react';
import dorks from './dorkdata';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import Alert from '@mui/material/Alert';
import {Link} from '@mui/material';
import {Paper} from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "../style/DorkListComposer.css"

const DorkListComposer = () => {
  const [selectedDorks, setSelectedDorks] = useState({});
  const [modifiedString, setModifiedString] = useState('');

  const handleCheckboxChange = (category, index) => {
    setSelectedDorks((prevSelectedDorks) => {
      const updatedSelectedDorks = {
        ...prevSelectedDorks,
        [category]: {
          ...(prevSelectedDorks[category] || {}),
          [index]: !prevSelectedDorks[category]?.[index] || false,
        },
      };

      if (!updatedSelectedDorks[category][index]) {
        delete updatedSelectedDorks[category][index];
      }

      return updatedSelectedDorks;
    });
  };

  const handleStringChange = (event) => {
    setModifiedString(event.target.value);
  };

  const openSelectedDorksInTabs = () => {
    const newWindow = window.open();
    Object.entries(selectedDorks).forEach(([category, selectedItems]) => {
      Object.keys(selectedItems).forEach((index) => {
        const dorkToOpen = dorks[category][index].replace('example.com', modifiedString);
        newWindow.open(`https://www.google.com/search?q=${encodeURIComponent(dorkToOpen)}`, '_blank');
      });
    });
  };
  const handleToggleAll = (category, value) => {
    setSelectedDorks((prevSelectedDorks) => {
      const updatedSelectedDorks = {
        ...prevSelectedDorks,
        [category]: dorks[category].reduce((acc, _, index) => {
          acc[index] = value;
          return acc;
        }, {}),
      };
      return updatedSelectedDorks;
    });
  };
  return (
    <div>
        <div style={{ zIndex: 1, position: 'sticky', top: 0, display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
         
            <TextField
            label="target.tld"
            fullWidth
            value={modifiedString}
            onChange={handleStringChange}
            variant="outlined"
            style={{ marginRight: '16px', backgroundColor: '#00000099' }}
            />
            
            <Button variant="contained" onClick={openSelectedDorksInTabs}>
                dorkit!
            </Button>
        
        </div>
        <Alert severity="warning" style={{ marginBottom: '16px' }}>
            <Typography >
                To view the search results in new tabs, please <Link target="_blank" href="https://support.google.com/chrome/answer/95472?hl=en&co=GENIE.Platform%3DDesktop#zippy=%2Callow-pop-ups-and-redirects-from-a-site">
                        allow pop-ups
                    </Link> in your browser for this site. This is necessary to ensure a seamless experience while exploring the dork results.
            </Typography>
        </Alert>

        

        {Object.entries(dorks).map(([category, dorkList]) => (
            <Accordion key={category}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h5">{category}</Typography>
                </AccordionSummary>
                <Paper elevation={3}>
                <AccordionDetails>
                        <ToggleButtonGroup
                            exclusive
                            onChange={(event, value) => handleToggleAll(category, value)}
                        >
                            <ToggleButton value={true}>Select All</ToggleButton>
                            <ToggleButton value={false}>Deselect All</ToggleButton>
                        </ToggleButtonGroup>
                        {dorkList.map((dork, index) => (
                            <div key={index}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={selectedDorks[category]?.[index] || false}
                                    onChange={() => handleCheckboxChange(category, index)}
                                />
                                }
                                label={dork}
                            />
                            </div>  
                        ))}
                </AccordionDetails>
                </Paper>
            </Accordion>
        ))}
    </div>
  );
};

export default DorkListComposer;
